import { render, staticRenderFns } from "./TripDataStops.vue?vue&type=template&id=3b4cd19f&scoped=true&"
import script from "./TripDataStops.vue?vue&type=script&lang=ts&"
export * from "./TripDataStops.vue?vue&type=script&lang=ts&"
import style0 from "./TripDataStops.vue?vue&type=style&index=0&id=3b4cd19f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cd19f",
  null
  
)

export default component.exports